export const adminRouteNames = {
  adminDashboard: 'admin-dashboard',
  monthlyReport: 'monthly-report',
  organizationReport: 'organization-report',
}
